var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 411,
    height: 537,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.248 510.688c-47.864-23.65-6.314-135.594-6.314-135.594l18.577-6.406 17.916 21.118",
    fill: "#B2B6B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.248 510.688c-47.864-23.65-6.314-135.594-6.314-135.594l18.577-6.406 17.916 21.118",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m308.766 567.973-31.731 8.769-10.675-38.63 31.731-8.769 10.675 38.63Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m308.766 567.973-31.731 8.769-10.675-38.63 31.731-8.769 10.675 38.63ZM410.371 539.896l-31.73 8.768-10.675-38.63 31.73-8.768 10.675 38.63Z",
    fill: "#E97D00",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m408.211 532.083 1.867 6.755c2.024 7.324-3.935 17.374-15.139 19.696-9.929 2.059-13.25 3.328-18.509 5.115-3.886 1.321-14.09 8.45-19.862 7.502-5.774-.948-12.571-8.289-3.596-14.161 8.976-5.869 22.945-7.442 25.375-9.384l-1.867-6.755",
    fill: "#E97D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m408.211 532.083 1.867 6.755c2.024 7.324-3.935 17.374-15.139 19.696-9.929 2.059-13.25 3.328-18.509 5.115-3.886 1.321-14.09 8.45-19.862 7.502-5.774-.948-12.571-8.289-3.596-14.161 8.976-5.869 22.945-7.442 25.375-9.384l-1.867-6.755",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M390.016 279.953c-31.906-17.287-102.183 22.574-102.183 22.574l-1.418-4.792-18.153 7.602-19.481 2.798 1.244 4.839-113.703 47.614s37.872 216.801 136.73 198.643c28.856-5.299 41.739-15.363 51.742-26.231 2.986-3.243 7.627-4.526 11.854-3.276 14.165 4.189 32.739 3.413 57.87-4.059 95.541-28.404 27.405-228.425-4.502-245.712Z",
    fill: "#B2B6B9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M390.016 279.953c-31.906-17.287-102.183 22.574-102.183 22.574l-1.418-4.792-18.153 7.602-19.481 2.798 1.244 4.839-113.703 47.614s37.872 216.801 136.73 198.643c28.856-5.299 41.739-15.363 51.742-26.231 2.986-3.243 7.627-4.526 11.854-3.276 14.165 4.189 32.739 3.413 57.87-4.059 95.541-28.404 27.405-228.425-4.502-245.712Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M347.994 301.317c-2.221-4.529-5.151-8.528-9.195-11.11-13.956-8.904-41.444 6.427-54.443 12.483a21.273 21.273 0 0 1-1.206-3.943c-5.387 2.198-11.008 4.662-16.455 7.023l-17.772 2.328 1.25 4.835c1.831 7.069-64.366 15.225-62.266 38.294.673 7.384 4.41 14.134 8.195 20.475 14.35 24.04 31.493 47.254 54.352 61.504 22.858 14.251 52.476 17.878 73.668 2.996 13.559-9.521 22.293-25.418 27.438-42.164 7.983-25.987 8.127-55.102.403-82.012-1.037-3.618-2.303-7.313-3.969-10.709Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 495.028c2.935 5.962-.099 10.935-6.743 11.049l-63.835 1.11c-6.645.114-14.934-4.42-18.42-10.078l-58.349-94.706c-3.486-5.658-.901-10.442 5.741-10.634l77.417-2.227c6.643-.19 14.479 4.532 17.414 10.494l46.775 94.992Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.672 495.028c2.935 5.962-1.559 15.313-8.202 15.429l-62.376-3.27c-6.646.115-14.934-4.42-18.42-10.078l-61.48-91.135c-3.485-5.658 2.229-14.013 8.871-14.205l77.418-2.227c6.643-.19 14.479 4.533 17.414 10.494l46.775 94.992Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M304.067 499.622c2.936 5.962-.099 10.935-6.743 11.049l-63.834 1.11c-6.646.114-14.934-4.42-18.42-10.078l-58.35-94.706c-3.486-5.658-.901-10.443 5.741-10.634l77.418-2.225c6.642-.192 14.479 4.53 17.414 10.492l46.774 94.992Z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M304.067 499.622c2.936 5.962-.099 10.935-6.743 11.049l-63.834 1.11c-6.646.114-14.934-4.42-18.42-10.078l-58.35-94.706c-3.486-5.658-.901-10.443 5.741-10.634l77.418-2.225c6.642-.192 14.479 4.53 17.414 10.492l46.774 94.992Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M369.053 351.825c-2.299 13.351 2.759 56.038 28.501 76.054 25.742 20.014 17.578 39.226 23.577 39.263 5.999.039 44.835-20.544 47.099-57.099 3.154-50.89-45.728-102.957-61.512-111.312",
    fill: "#B2B6B9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M369.053 351.825c-2.299 13.351 2.759 56.038 28.501 76.054 25.742 20.014 17.578 39.226 23.577 39.263 5.999.039 44.835-20.544 47.099-57.099 3.154-50.89-45.728-102.957-61.512-111.312",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M407.649 414.292c6.263 8.442 21.885 26.379 20.982 49.519",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M145.477 425.064c13.13 19.898 23.094 26.046 54.915 26.154 24.468.083 41.273-2.504 50.692-4.199 1.444 6.582-10.422 52.474-44.475 67.373-23.439 10.256-45.873 5.009-61.115-4.132",
    fill: "#B2B6B9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.477 425.064c13.13 19.898 23.094 26.046 54.915 26.154 24.468.083 41.273-2.504 50.692-4.199 1.444 6.582-10.422 52.474-44.475 67.373-23.439 10.256-45.873 5.009-61.115-4.132",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.797 463.97c10.975 2.902 31.536.611 47.805-7.795M199.154 477.417c11.084 3.296 33.288-.722 46.643-9.908M196.47 489.18c8.001 2.875 34.075-.939 44.909-10.356M191.206 500.808c15.482.807 31.956-2.473 43.281-9.923M188.982 511.172c13.12 1.46 27.038-4.929 34.872-8.789",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M150.051 358.83s42.701 8.598 125.342-14.239c82.643-22.837 110.695-56.703 110.695-56.703s-70.168-32.048-72.931-30.765c-2.764 1.283-83.515 23.074-83.515 23.074l-45.101 68.063-34.49 10.57Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M150.051 358.83s42.701 8.598 125.342-14.239c82.643-22.837 110.695-56.703 110.695-56.703s-70.168-32.048-72.931-30.765c-2.764 1.283-83.515 23.074-83.515 23.074l-45.101 68.063-34.49 10.57Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M378.824 86.734C337.448 34.778 239.427 41.08 195.015 53.352 150.604 65.625 63.256 110.547 54.429 176.377c-8.828 65.83.668 152.568 32.308 177.087 50.91 39.45 144.212 14.187 171.375-71.779 68.817 61.001 163.281 28.663 183.916-26.401 14.046-37.483-21.827-116.593-63.204-168.55Z",
    fill: "#B2B6B9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M378.824 86.734C337.448 34.778 239.427 41.08 195.015 53.352 150.604 65.625 63.256 110.547 54.429 176.377c-8.828 65.83.668 152.568 32.308 177.087 50.91 39.45 144.212 14.187 171.375-71.779 68.817 61.001 163.281 28.663 183.916-26.401 14.046-37.483-21.827-116.593-63.204-168.55Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M73.934 152.396c-14.754-.193-43.109-6.907-58.103-20.354 0 0 1.067 60.111 37.329 71.704",
    fill: "#B2B6B9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.934 152.396c-14.754-.193-43.109-6.907-58.103-20.354 0 0 1.067 60.111 37.329 71.704",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m269.3 340.142 4.103 14.848s-18.002 19.357-24.045 17.832c-6.044-1.527-14.284-37.604-10.676-40.2 3.606-2.594 30.618 7.52 30.618 7.52Z",
    fill: "#31B1B6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m269.3 340.142 4.103 14.848s-18.002 19.357-24.045 17.832c-6.044-1.527-14.284-37.604-10.676-40.2 3.606-2.594 30.618 7.52 30.618 7.52Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m279.657 337.281 4.103 14.847s25.387 7.367 29.789 2.956c4.403-4.414-7.051-39.603-11.479-39.978-4.427-.374-22.413 22.175-22.413 22.175Z",
    fill: "#31B1B6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m279.657 337.281 4.103 14.847s25.387 7.367 29.789 2.956c4.403-4.414-7.051-39.603-11.479-39.978-4.427-.374-22.413 22.175-22.413 22.175Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m283.849 352.102-11.248 3.109-4.103-14.848 11.248-3.108 4.103 14.847Z",
    fill: "#31B1B6",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M298.727 91.374c-38.791 10.719-58.641 46.471-67.107 67.146-2.74 6.689-11.662 9.155-17.445 4.821-17.883-13.394-53.273-33.881-92.064-23.161-76.73 21.203-60.171 176.982-4.632 206.366 46.719 24.718 121.4-26.055 136.574-72.869 30.557 28.276 127.212 37.603 154.61-7.597 32.571-53.732-31.416-196.404-109.936-174.706Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m248.103 245.574.206 1.002-.338-.965c-6.759 1.867-9.743 23.033-5.353 31.395 4.388 8.36 16.207 22.219 20.003 21.62.024-.005.037-.034.06-.042.022-.005.049.013.072.005 3.564-1.435 6.59-19.396 6.064-28.823-.527-9.429-13.956-26.059-20.714-24.192Z",
    fill: "#E97D00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m248.103 245.574.206 1.002-.338-.965c-6.759 1.867-9.743 23.033-5.353 31.395 4.388 8.36 16.207 22.219 20.003 21.62.024-.005.037-.034.06-.042.022-.005.049.013.072.005 3.564-1.435 6.59-19.396 6.064-28.823-.527-9.429-13.956-26.059-20.714-24.192Z",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M201.992 243.121c5.888 21.31-.846 41.767-15.043 45.69-14.197 3.923-30.48-10.173-36.369-31.483-5.888-21.31.846-41.767 15.043-45.69 14.197-3.923 30.48 10.173 36.369 31.483ZM333.138 205.321c5.889 21.31-.846 41.767-15.043 45.69-14.196 3.924-30.48-10.173-36.368-31.483-5.889-21.309.846-41.767 15.042-45.69 14.197-3.923 30.48 10.174 36.369 31.483Z",
    fill: "#3E3E3C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M172.013 311.195c-32.99 9.116-67.126-10.238-76.242-43.228-9.117-32.991 10.238-67.127 43.228-76.243 32.99-9.117 67.126 10.238 76.243 43.228 9.116 32.991-10.238 67.126-43.229 76.243Zm-36.137-130.772c-39.234 10.842-62.25 51.435-51.408 90.667 10.842 39.234 51.435 62.249 90.669 51.408 39.234-10.842 62.248-51.435 51.406-90.669-10.842-39.232-51.433-62.248-90.667-51.406Z",
    fill: "#31B1B6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m95.427 293.226-43.178-.635-6.92-25.043 36.725-22.715 13.373 48.393ZM270.716 219.623c-9.117-32.991 10.238-67.126 43.228-76.243 32.99-9.116 67.126 10.238 76.243 43.228 9.116 32.991-10.238 67.126-43.229 76.243-32.99 9.116-67.126-10.238-76.242-43.228Zm-11.301 3.123c10.841 39.232 51.433 62.248 90.666 51.406 39.232-10.841 62.25-51.435 51.409-90.667-10.842-39.234-51.437-62.247-90.669-51.406-39.234 10.842-62.248 51.433-51.406 90.667Z",
    fill: "#31B1B6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m403.452 208.107 34.91-22.214-6.92-25.043-41.363-1.136 13.373 48.393ZM265.017 215.628l-47.909 13.239-5.483-19.842 47.909-13.239 5.483 19.842Z",
    fill: "#31B1B6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 132.043s4.817 36.784 38.598 44.335",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 132.043s4.489 50.643 38.271 58.194",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M349.802 76.163c12.562-7.742 33.446-28.062 39.409-47.3 0 0 29.949 52.13 4.785 80.697",
    fill: "#B2B6B9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M349.802 76.163c12.562-7.742 33.446-28.062 39.409-47.3 0 0 29.949 52.13 4.785 80.697",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M389.211 28.863s14.755 34.038-10.356 57.863",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M389.211 28.863s22.152 45.763-2.96 69.588",
    stroke: "#3E3E3C",
    strokeWidth: 2.667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwl);
export default __webpack_public_path__ + "static/media/owl.ebd5f873f96e8d91b16c45f932880f50.svg";
export { ForwardRef as ReactComponent };